exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tableFilter>thead>tr{\n  background: #1C869A;\n  color: white;\n}\n", ""]);

// exports
